// A picking order under review must never reach the label screen. What the operator
// should do with the tote depends on why: only a cancelled order (the single writer of
// `interrupted`) frees its totes, so only then must the tote be emptied. Every other
// reason — missing piece, blocked or expired lot — returns the order to packing with
// its pieces still inside.
const KEYS = {
  inReview: 'generate_shipment.view.order_in_review',
  inReviewWithNumber: 'generate_shipment.view.order_in_review_with_number',
  canceled: 'generate_shipment.view.order_canceled_in_review',
  canceledWithNumber: 'generate_shipment.view.order_canceled_in_review_with_number',
  canceledWithTotes: 'generate_shipment.view.order_canceled_in_review_with_totes',
}

export const getReviewBlockMessage = pickingOrder => {
  if (!pickingOrder?.in_review) return null

  const orderNumber = pickingOrder.order?.order_number

  if (pickingOrder.order?.status !== 'interrupted') {
    return orderNumber ? { key: KEYS.inReviewWithNumber, params: { order_number: orderNumber } } : { key: KEYS.inReview, params: {} }
  }

  // A cancelled multipicker order holds one tote per task; a released one needs no trip.
  const toteCodes = (pickingOrder.totes ?? []).filter(tote => tote.status === 'in_use').map(tote => tote.unique_code)

  if (orderNumber && toteCodes.length > 1) {
    return { key: KEYS.canceledWithTotes, params: { order_number: orderNumber, totes: toteCodes.join(', ') } }
  }
  return orderNumber ? { key: KEYS.canceledWithNumber, params: { order_number: orderNumber } } : { key: KEYS.canceled, params: {} }
}
